// extracted by mini-css-extract-plugin
export var infoRow = "_ud-2";
export var labelContainer = "_ud-0";
export var rightInfo = "_ud-1";